
import { Component, Prop, Vue } from "vue-property-decorator";
import dayjs from "dayjs";
import { namespace } from "vuex-class";
import { emptyToLine } from "@common/src/utils/common";
import { addCurrencyUnit } from "@common/src/utils/tools";
import SettlementTable from "./settlement-table-print.vue";

const service = namespace("service");
const staff = namespace("staff");
const setting = namespace("setting");
const store = namespace("store");
@Component({ components: { SettlementTable } })
export default class SettlementPrint extends Vue {
  @staff.Action getStaffList;
  @service.Action getPrintStoreLogo;
  @setting.Action queryPrintFieldListByCategory;
  @setting.Action queryPrintFieldListByCode;
  @store.State storeData;
  @Prop({ default: () => {}, type: Object })
  orderData: any;
  @Prop({ default: () => {}, type: Object })
  orderDataFake: any;
  @Prop({ default: "" })
  printTemplateCode: string;
  printLogo: string = "https://static.gtech.asia/static/speedbiz/speedbiz_logo.png";
  dayjs = dayjs;
  emptyToLine = emptyToLine;
  addCurrencyUnit = addCurrencyUnit;
  advisorList: any[] = [{}];
  fieldList: any = [];
  get availableFieldArr() {
    return this.fieldList.filter(item => item.status === 1).map(item => item.fieldCode);
  }
  created() {
    console.log("[ $orderData.allOrderDetail ]", this.$orderData.allOrderDetail);
    this.getStaffList({
      // 获取所有员工
      pageNum: 1,
      pageSize: 999
    }).then(data => {
      this.advisorList = data.data.list;
    });
    this.getLogoImg();
    this.getTemplateField();
  }
  getLogoImg() {
    this.getPrintStoreLogo().then(res => {
      this.printLogo = res.data.storeLogo;
    });
  }
  templateServicePhone: string = "";
  customerNotice = "";
  queryPrintTemplateCode = "";
  storeNameBySource = "";
  getTemplateField() {
    const queryFn = this.isPreview ? this.queryPrintFieldListByCode : this.queryPrintFieldListByCategory;
    const queryParams = this.isPreview
      ? { printTemplateCode: this.printTemplateCode }
      : { category: "PRINT_PAYMENT_CREDENTIALS" };
    queryFn(queryParams).then(data => {
      this.fieldList = data.data?.printFieldList || [];
      this.customerNotice = data.data?.customerNotice || "";
      this.templateServicePhone = data.data?.templateServicePhone || "";
      this.queryPrintTemplateCode = data.data?.printTemplateCode;
      this.storeNameBySource = data.data?.storeName || "";
    });
  }
  returnStaffName(userCode) {
    let obj = userCode ? this.advisorList.find(item => item.userCode === userCode) : "";
    return obj ? obj.staffName : "";
  }
  get $orderData() {
    return this.orderData || this.orderDataFake;
  }
  get customerNoticeList() {
    return this.customerNotice.split("\n");
  }
  get isThree() {
    return (
      (this.printTemplateCode || this.queryPrintTemplateCode) === "PRINT_PAYMENT_CREDENTIALS_THREE" ||
      (this.printTemplateCode || this.queryPrintTemplateCode) === "PRINT_DELEGATION_CREDENTIALS_THREE"
    );
  }
  get isPreview() {
    return !!this.printTemplateCode;
  }
}
